import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import SchedulePage from './pages/SchedulePage';
import OrdersPage from './pages/OrdersPage';
import OrdersHistoryPage from './pages/OrdersHistoryPage';
import TrucksPage from './pages/TrucksPage';
import DriversPage from './pages/DriversPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import OrderDetails from './pages/OrderDetails';
import HeaderNav from './Components/HeaderNav';
import './App.css';
import TruckRequest from './Utills/TruckRequest';
import WhereSystem from './WhereSystem';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function WithHeaderLayout() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <HeaderNav />
      <div style={{ flex: 1 }}>
        <Outlet />
      </div>
    </div>
  );
}

function App() {
  const navigate = useNavigate();

  const [configReady, setConfigReady] = useState(false);

  useEffect(() => {
    TruckRequest.getJson("./assets/appConfig.json", true, (config) => {
      try {
        if (config && config.api && config.api.url) {
          WhereSystem.initApp(config);
        } else {
          console.error('Invalid appConfig.json', config);
        }
      } finally {
        setConfigReady(true);
      }
    });
  }, []);

  if (!configReady) {
    return null; // or a splash/loading UI
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage onSuccess={() => navigate('/')} />} />
      <Route element={<ProtectedRoute><WithHeaderLayout /></ProtectedRoute>}>
        <Route path="/" element={<MainPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders-history" element={<OrdersHistoryPage />} />
        <Route path="/trucks" element={<TrucksPage />} />
        <Route path="/drivers" element={<DriversPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/order-details" element={<OrderDetails />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
